import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gtag } from "../utils/util";

function GtagRouterTracker() {
  const location = useLocation();

  useEffect(() => {
    // Get the actual path (replace IDs for dynamic routes)
    let pagePath = location.pathname;

    // Example: Convert "/qr/123" to "/qr/[id]"
    if (/\/qr\/\w+/.test(pagePath)) {
      pagePath = "/qr/[id]";
    }

    // Track page view
    if (typeof gtag === "function") {
      gtag("event", "page_view", {
        page_title: document.title,
        page_path: pagePath,
        page_location: window.location.href,
      });
    }
  }, [location]);

  return null;
}

export default GtagRouterTracker;
